import type { FileEditSchemaEditPayload } from '@repo/schemas/file/fileEdit';

import { useQueryClient } from '@tanstack/react-query';

import { useBatchMutation } from '#batch-mutations/useBatchMutations';
import { DirectoryKey } from '#directory/keys';

import { FileService } from './fileService';

export function useEditFiles(directoryId?: string) {
  const queryClient = useQueryClient();

  return useBatchMutation({
    mutationFn: (data: FileEditSchemaEditPayload) => FileService.editFile(data).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DirectoryKey.DIRECTORY, directoryId],
      });
    },
  });
}
